"use client";

import React from "react";
import Link from "next/link";
import { useParams } from "next/navigation";
import styles from "./appBreadcrumbs.module.css";

interface BreadcrumbItem {
  title: string;
  href?: string;
}

interface AppBreadcrumbsProps {
  items: BreadcrumbItem[];
  isLoading?: boolean;
}

export default function AppBreadcrumbs({ items, isLoading }: AppBreadcrumbsProps) {
  const params = useParams();
  const locale = (params?.locale as string) || "vi";

  const getHref = (href?: string) => {
    if (!href || href === "#") return "#";
    if (href.startsWith("http://") || href.startsWith("https://")) return href;
    const cleanHref = href.startsWith("/") ? href : `/${href}`;
    if (cleanHref.startsWith(`/${locale}/`) || cleanHref === `/${locale}`) {
      return cleanHref;
    }
    return `/${locale}${cleanHref}`;
  };

  if (isLoading) {
    return <div className={styles.skeleton} />;
  }

  return (
    <nav aria-label="Breadcrumb">
      <ol className={styles.breadcrumbs}>
        {items?.map((item, index) => {
          const isLast = index === items.length - 1;
          
          return (
            <li key={index} className={styles.item}>
              {isLast ? (
                <span className={`${styles.link} ${styles.active}`} aria-current="page">
                  {item.title}
                </span>
              ) : (
                <>
                  <Link href={getHref(item.href)} className={styles.link}>
                    {item.title}
                  </Link>
                  <span className={styles.separator}>/</span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
